import { Grid } from '@mui/material';
import React from 'react';
import styles from './styles.module.css';
import Backbone from './Backbone.png';
import Arms from './Arms.png';
import Legs from './Legs.png';
import ArmsAndLegs from './Arms-Legs.png';
import { SlideSubtitle } from '../slide-subtitle/slide-subtitle';
import { SlideParagraph } from '../slide-paragraph';
import { Slide } from '../../../_data';
import { EditableField } from '../../../components/EditableField';

export type PortfolioStoryProps = [
  {
    field: 'text';
    label: string;
    value: string;
    type: 'text';
  },
  {
    field: 'backbone';
    label: string;
    value: string;
    type: 'text';
  },

  {
    field: 'armsLegs';
    label: string;
    value: string;
    type: 'text';
  },
  {
    field: 'arms';
    label: string;
    value: string;
    type: 'text';
  },
  {
    field: 'legs';
    label: string;
    value: string;
    type: 'text';
  },
];

export const PortfolioStory = React.memo(
  ({
    slide,
    onChangeSlide,
  }: {
    slide: Slide<PortfolioStoryProps>;
    onChangeSlide: (
      slide: Slide<PortfolioStoryProps>,
      content: PortfolioStoryProps,
    ) => void;
  }): React.ReactElement => {
    return (
      <Grid container direction="column" className={styles.container}>
        <Grid item>
          <EditableField
            field="title"
            slide={slide}
            style={{
              fontSize: '25px',
              fontWeight: 700,
              color: '#004F7E',
            }}
            onSlideContentChange={onChangeSlide}
          />
          <SlideSubtitle style={{ fontSize: '18px', padding: '10px 0' }}>
            Written from the voice of the advisor
          </SlideSubtitle>

          <SlideParagraph style={{ paddingBottom: '20px', color: '#353536' }}>
            We&apos;ve built a portfolio that takes a dynamic approach to
            investing, adapting to changing market cycles and adjusting for
            today&apos;s opportunities. The portfolio was created from a mix of
            strategies that were specifically selected to play a unique role
            within the portfolio.
          </SlideParagraph>
        </Grid>
        <Grid
          item
          container
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          style={{
            margin: '10px 0',
          }}
        >
          <Grid item xs={12} md={2}>
            <div
              style={{
                width: '100px',
                height: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={Backbone}
                alt="Backbone"
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={10}>
            <EditableField
              field="backbone"
              slide={slide}
              onSlideContentChange={onChangeSlide}
              style={{
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: '15px',
                color: '#353536',
              }}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          spacing={2}
          alignItems="center"
          style={{
            margin: '10px 0',
          }}
        >
          <Grid item xs={12} md={2}>
            <div
              style={{
                width: '100px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={ArmsAndLegs}
                alt="ArmsAndLegs"
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={10}>
            <EditableField
              field="armsLegs"
              slide={slide}
              onSlideContentChange={onChangeSlide}
              style={{
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: '15px',
                color: '#353536',
              }}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          spacing={2}
          alignItems="center"
          style={{
            margin: '10px 0',
          }}
        >
          <Grid item xs={12} md={2}>
            <div
              style={{
                width: '100px',
                height: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={Arms}
                alt="Arms"
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={10}>
            <EditableField
              field="arms"
              slide={slide}
              onSlideContentChange={onChangeSlide}
              style={{
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: '15px',
                color: '#353536',
              }}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          spacing={2}
          alignItems="center"
          style={{
            margin: '10px 0',
          }}
        >
          <Grid item xs={12} md={2}>
            <div
              style={{
                width: '100px',
                height: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={Legs}
                alt="Legs"
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={10}>
            <EditableField
              field="legs"
              slide={slide}
              onSlideContentChange={onChangeSlide}
              style={{
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: '15px',
                color: '#353536',
              }}
            />
          </Grid>
        </Grid>
        <Grid item>
          <SlideParagraph style={{ paddingTop: '20px', color: '#353536' }}>
            We selected these strategies from a list of solutions that have gone
            through AssetMark&apos;s due diligence review process. These
            strategies are continuously monitored by a dedicated team of
            research analysts at AssetMark, and should there be any concerns, we
            can make changes to your portfolio.
          </SlideParagraph>
        </Grid>
      </Grid>
    );
  },
);
